
const state = {
    snackbars:[],
    course_offering_learner_id:null,
    notification:null,
    rssdi_data:null,
}

const getters = {
    allSnakbars:(state) => state.snackbars,
    course_offering_learner_id: state => state.course_offering_learner_id,
    notification: state => state.notification,
    rssdi_data: state => state.rssdi_data,
}

const actions = {
    setSnackbar({commit}, snackbar) {
        snackbar.showing = snackbar.showing || true;
        snackbar.color = snackbar.color || 'success';
        snackbar.timeout = snackbar.timeout || 500;
        commit('SET_SNACKBAR', snackbar);
    },
      
}

const mutations = {
    SET_SNACKBAR(state, snackbar) {
        state.snackbars = state.snackbars.concat(snackbar);
    },
    setcourse_offering_learner(state,course_offering_learner_id){
        state.course_offering_learner_id = course_offering_learner_id
    },
    setnotification(state,notification){
        state.notification = notification
    },
    setrssdi_data(state,rssdi_data){
        state.rssdi_data = rssdi_data
    },
}

export default{
    state,
    getters,
    actions,
    mutations,
}

